const { windowLoaded } = require('@grpn/document-states');
const checkExperiment = require('src/frontend/helper/experiment');
const loadAsyncJS = require('./m_loadAsyncJS');
const { readLdJSON } = require('./m_readLdJSON');
const { unescape } = require('../underscore/unescape');

(function(gtm) {
  const gtmData = readLdJSON('gtmData');
  const cCookie = Cookie.get('c');
  const eCookie = Cookie.get('e');
  if (gtmData.data) {
    try {
      gtm = JSON.parse(unescape(unescape(gtmData.data)));
    } catch (error) {}
  }

  if (cCookie && eCookie) {
    gtm.dl_user_id = cCookie;
    gtm.dl_email_sha256 = eCookie;
  }

  gtm.platform = gtmData.platform;
  window.dataLayer = [gtm];
  if (gtmData.enabled) {
    function loadGTM() {
      checkExperiment('LS-4100-intentmedia-gtm', {
        Treatment() {
          window.dataLayer.push({ 'LS-4100-intentmedia-gtm': true });
        },
      });
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });
      const src = new URL('gtm.js', 'https://www.googletagmanager.com');
      if (gtmData.id) {
        src.searchParams.set('id', gtmData.id);
      }
      return loadAsyncJS(src.toString());
    }

    windowLoaded.then(() => {
      loadGTM();
    });
  }
})({});
